module.exports = __webpack_public_path__ + "static/media/MaintenanceChar-Mobile.b7691cd3.png";